/**
 * Reads the Google Analytics client id from the analytics.js global, mirroring
 * the Ember login (`getGoogleAnalyticsClientID`). The login authenticators
 * require a `ga_client_id` string; when GA hasn't loaded we send an empty
 * string rather than failing the login.
 */
type GaGlobal = {
  getAll?: () => Array<{ get: (key: string) => string | undefined }> | undefined;
};

export function getGaClientId(): string {
  const ga = (window as unknown as { ga?: GaGlobal }).ga;
  return ga?.getAll?.()?.[0]?.get('clientId') ?? '';
}
